import React, { Fragment, useEffect, useRef, useState } from "react";
import SEO from "../../components/seo";
import LayoutTwo from "../../layouts/LayoutTwo";
import HeroSliderThree from "../../wrappers/hero-slider/HeroSliderThree";
import CategoryOneSlider from "../../wrappers/category/CategoryOneSlider";
import SectionTitleWithText from "../../components/section-title/SectionTitleWithText";
import TabProductThree from "../../wrappers/product/TabProductThree";
import BannerThree from "../../wrappers/banner/BannerThree";
import BrandLogoSliderNCD from "../../wrappers/brand-logo//BrandLogoSliderNCD";
import Loader from "../../components/Loader";
import { useSelector } from "react-redux";
import { getUserPrefersLang } from "../../shared/helpersMethod";
import BussinessReviewOne from "../../wrappers/bussiness-reviews/BussinessReviewOne";
import BussinessAppLink from "../../wrappers/bussiness-app-links/bussinessAppLink";

import { useAppSelector } from "../../hooks/useReduxMethods";
import useGateWays from "../../hooks/useBillingGateways";
import CountDownTwo from "../../wrappers/countdown/CountDownTwo";
import CountDownOne from "../../wrappers/countdown/CountDownOne";
import CountDownEight from "../../wrappers/countdown/CountDownEight";
import CountDownSeven from "../../wrappers/countdown/CountDownSeven";
import CountdownTimer from "../../components/countdown";
import FeatureIcon from "../../wrappers/feature-icon/FeatureIcon";
import FeatureIconEight from "../../wrappers/feature-icon/FeatureIconEight";
import FeatureIconThreeSingle from "../../components/feature-icon/FeatureIconThreeSingle";
import FeatureIconThree from "../../wrappers/feature-icon/FeatureIconThree";
import FeatureIconFive from "../../wrappers/feature-icon/FeatureIconFive";
import FeatureIconFour from "../../wrappers/feature-icon/FeatureIconFour";
import FontFamilySelector from "../../shared/font-family-selector";
import BrandLogoSliderOne from "../../wrappers/brand-logo/BrandLogoSliderOne";
import useGetHomeCategory from "../../hooks/useGetCategories";
import ArrowLeft from "../../assets/svgs/ArrowLeft";
const HomeElectronics = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const scrollRefCategories = useRef(null);
  const [isScrollableLeft, setIsScrollableLeft] = useState(false);
  const [isScrollableRight, setIsScrollableRight] = useState(false);
  const { getMobileMenu, mobileMenu, mobileMenuLoading } = useGetHomeCategory();
  const { bussinessData } = useAppSelector((state) => state.bussinessData);
  const { paymentData } = useAppSelector((state) => state.paymentGateways);

  // const { homePageCategories, getHomePageCategory, loading } =
  //   useGetHomeCategory();
  const targetTime = new Date();
  targetTime.setHours(
    targetTime.getHours() + 28,
    targetTime.getMinutes() + 5,
    targetTime.getSeconds() + 20
  );
  const curretnLang = getUserPrefersLang();
  useEffect(() => {
    const container = scrollRefCategories.current;
    const handleScroll = () => {
      if (curretnLang == "en" && null !== container) {
        setIsScrollableLeft(container.scrollLeft > 0);
        setIsScrollableRight(
          container.scrollLeft + container.clientWidth < container.scrollWidth
        );
        return;
      }
      if (curretnLang == "ar" && null !== container) {
        setIsScrollableRight(container.scrollLeft < 0);
        setIsScrollableLeft(
          Math.abs(container.scrollLeft) <
            container.scrollWidth - container.clientWidth
        );
        return;
      }
    };
    if (null !== container) {
      handleScroll(); // Initial check
      // Listen to scroll events
      container.addEventListener("scroll", handleScroll);
    }

    // Clean up event listener
    return () => {
      if (null !== container) {
        container.removeEventListener("scroll", handleScroll);
      }
    };
  }, [curretnLang]);
  useEffect(() => {
    if (curretnLang === "ar") {
      document.getElementsByTagName("html")[0].setAttribute("lang", "ar");
      document.getElementsByTagName("body")[0].setAttribute("dir", "rtl");
    }
  }, []);
  useEffect(() => {
    console.log("width", window.screen.width);
    if (
      window.screen.width < 1000 &&
      bussinessData?.homepage_configurations?.display_sections
        .display_mobile_menu_categories === "Yes"
    ) {
      getMobileMenu("mobile", "Y");
    }
  }, [window.screen.width]);
  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, [bussinessData]);
  const MobileMenuCategoriesAfterSlider = () => {
    return (
      <div
        style={{ paddingTop: 30 }}
        className="mobile-department d-lg-none bg-glaucous "
      >
        <ul ref={scrollRefCategories}>
          <CustomLeftArrow
            onClick={() => {
              if (scrollRefCategories.current) {
                scrollRefCategories.current.scrollLeft -= 100; // Adjust scroll amount as needed
              }
            }}
          />
          <CustomRightArrow
            onClick={() => {
              if (scrollRefCategories.current) {
                scrollRefCategories.current.scrollLeft += 100; // Adjust scroll amount as needed
              }
            }}
          />
          <Fragment>
            {!mobileMenuLoading &&
              mobileMenu &&
              mobileMenu.map((item: any, index: number) => {
                return (
                  <li key={index}>
                    <div className="mobile-nav-menu-items">
                      <a
                        onClick={() => updateCategoryBreadCrums(item)}
                        href={`/collections/${item.slug}/${item.unique_id}`}
                        className="waiting lazyloaded"
                      >
                        <img
                          style={{ maxWidth: 120, borderRadius: 120 }}
                          height="120"
                          width="120"
                          alt={item.name}
                          className="img-categories-mobile-view"
                          src={item.category_template_image}
                        />
                      </a>
                      <span className="text-mobile-menu bold">{item.name}</span>
                    </div>
                  </li>
                );
              })}
          </Fragment>
        </ul>
      </div>
    );
  };
  const CustomRightArrow = ({ onClick }) => {
    // onMove means if dragging or swiping in progress.
    // <button aria-label="Go to previous slide" class="react-multiple-carousel__arrow react-multiple-carousel__arrow--left " type="button" onClick={() => onClick()}></button>
    return (
      <button
        // disabled={!isScrollableRight}
        className="mobile-nav-arrow right"
        style={{
          right: 0,
          // boxShadow: "4px 2px 7px 8px rgba(159,197,234,.49)",
          // left: userLang == 'ar' && 0,
          // borderLeft: "1px solid black",
        }}
        onClick={onClick}
      >
        <ArrowLeft />
      </button>
    );
  };
  const CustomLeftArrow = ({ onClick }) => {
    // onMove means if dragging or swiping in progress.
    // <button aria-label="Go to previous slide" class="react-multiple-carousel__arrow react-multiple-carousel__arrow--left " type="button" onClick={() => onClick()}></button>
    return (
      <button
        // disabled={!isScrollableLeft}
        className="mobile-nav-arrow left"
        style={{
          // right: userLang == 'ar' && 0,
          left: 0,
          // boxShadow: "4px 2px 7px 1px rgba(159,197,234,.49)",
          //  left: 0,
          // borderRight: "1px solid black"
        }}
        onClick={onClick}
      >
        <ArrowLeft dimension="right" />
      </button>
    );
  };
  return (
    <div className="scroll-x-none">
      {!loading && bussinessData && Object.keys(bussinessData).length !== 0 ? (
        <Fragment>
          <SEO
            title={
              bussinessData?.site_settings?.siteTitle !== ""
                ? bussinessData?.site_settings?.siteTitle
                : "Home"
            }
            titleTemplate="Home"
            description="home"
          />
          {/* <FontFamilySelector /> */}
          <LayoutTwo>
            {bussinessData?.homepage_configurations?.display_sections
              ?.display_home_slider === "Yes" && (
              <HeroSliderThree
                homePageSlider={
                  bussinessData?.homepage_configurations?.homepage_slider
                    ?.slides
                }
              />
            )}
            {bussinessData?.homepage_configurations?.display_sections
              .display_mobile_menu_categories === "Yes" &&
              !mobileMenuLoading &&
              bussinessData?.homepage_configurations?.display_sections
                .mobile_categories_menu === "after_slider" && (
                <div
                  style={{ paddingTop: 30 }}
                  className="mobile-department d-lg-none bg-glaucous "
                >
                  <ul ref={scrollRefCategories}>
                    <CustomLeftArrow
                      onClick={() => {
                        console.log("caaa");
                        if (scrollRefCategories.current) {
                          scrollRefCategories.current.scrollLeft -= 100; // Adjust scroll amount as needed
                        }
                      }}
                    />
                    <CustomRightArrow
                      onClick={() => {
                        if (scrollRefCategories.current) {
                          scrollRefCategories.current.scrollLeft += 100; // Adjust scroll amount as needed
                        }
                      }}
                    />

                    {!mobileMenuLoading &&
                      mobileMenu &&
                      mobileMenu.map((item: any, index: number) => {
                        return (
                          <li key={index}>
                            <div className="mobile-nav-menu-items">
                              <a
                                onClick={() => updateCategoryBreadCrums(item)}
                                href={`/collections/${item.slug}/${item.unique_id}`}
                                className="waiting lazyloaded"
                              >
                                <img
                                  style={{ maxWidth: 120, borderRadius: 120 }}
                                  height="120"
                                  width="120"
                                  alt={item.name}
                                  className="img-categories-mobile-view"
                                  src={item.category_template_image}
                                />
                              </a>
                              <span className="text-mobile-menu bold">
                                {item.name}
                              </span>
                            </div>
                          </li>
                        );
                      })}
                  </ul>
                </div>
                // <MobileMenuCategoriesAfterSlider />
              )}

            {bussinessData.countDown && <FeatureIconFour />}
            {bussinessData?.homepage_configurations?.display_sections
              ?.display_featured_categories === "Yes" && (
              <CategoryOneSlider
                spaceBottomClass="pb-95 "
                topSpaceClass="pt-30 "
                homePageCategories={
                  bussinessData?.homepage_configurations?.homepage_categories
                }
              />
            )}
            {/* section title with text */}

            {"Yes" ===
              bussinessData?.homepage_configurations?.display_sections
                ?.display_google_review && (
              <BussinessReviewOne
                spaceBottomClass="pb-20"
                spaceTopClass="pt-20"
              />
            )}
            {/* brand logo slider */}
            {bussinessData?.homepage_configurations?.display_sections
              ?.display_brands === "Yes" && (
              <BrandLogoSliderOne
                homePageBrandLogo={
                  bussinessData?.homepage_configurations?.homepage_brands
                }
                spaceBottomClass="pb-20"
                spaceTopClass="pt-20"
              />
            )}
            {bussinessData?.homepage_configurations?.display_sections
              ?.display_product_carousal === "Yes" && (
              <TabProductThree
                spaceBottomClass="pb-60"
                category="خلاط يدوي"
                homepageCarouselSlider={
                  bussinessData?.homepage_configurations
                    ?.homepage_carousel_slider
                }
              />
            )}
            {/* brand logo slider */}
            {bussinessData?.homepage_configurations?.display_sections
              ?.display_featured_products === "Yes" && (
              <BannerThree
                bannerData={
                  bussinessData?.homepage_configurations
                    ?.homepage_featured_product
                }
              />
            )}
            {bussinessData?.homepage_configurations?.display_sections
              ?.display_info_section === "Yes" && (
              <SectionTitleWithText
                spaceBottomClass=" pt-40 pb-40"
                welcomeInfo={
                  bussinessData?.homepage_configurations?.welcome_info
                }
              />
            )}
            {bussinessData?.businessMobileApps && (
              <BussinessAppLink data={bussinessData?.businessMobileApps} />
            )}
            {[140].includes(bussinessData.businessID) && (
              <BrandLogoSliderNCD
                homePageBrandLogo={
                  bussinessData?.homepage_configurations?.homepage_brands
                }
                spaceBottomClass="pb-20"
                spaceTopClass="pt-20"
              />
            )}
          </LayoutTwo>
        </Fragment>
      ) : (
        <Loader />
      )}
    </div>
  );
};

export default HomeElectronics;
